import { buildQuery, containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const customPointTypes = "api/customPointTypes";
const pointsQuery = {
    orderBy: "id desc",
};

const list = (params: {}) => request(`${customPointTypes}/getList${containsQuery(params)}`, { method: "GET" });

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...pointsQuery });
    return request(`${customPointTypes}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const apply = (params: {}) => alertRequest(`${customPointTypes}/apply`, body(params));

const getItem = ({ id }: { id: string }) => {
    const query = buildQuery({ filter: { id: parseInt(id) } });
    return request(`${customPointTypes}/getlist${query}`, { method: "GET" }).then(
        (data) => data && data.length > 0 && data[0],
    );
};

const delItem = (params: {}) => alertRequest(`${customPointTypes}/delete`, body(params));

export { list, apply, index, getItem, delItem };
